import { createErrorPayload } from "@/common/utils/error/errorHandler";
import "whatwg-fetch";
//import { constants } from "@/lib/CONSTANTS";

export const HTTP_METHODS = { GET: "GET", POST: "POST" };

export async function executeRequest(
  { url, method, body, headers = {}, credentials = "same-origin" },
  authorizedRequest
) {
  if (typeof authorizedRequest !== "boolean") {
    throw new Error("authorizedRequest is missing");
  }
  if (!headers["Accept"]) {
    headers["Accept"] = "application/json";
  }
  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  try {
    if (!headers["Authorization"] && authorizedRequest) {
      let jwt = ""; //getJwt();
      headers["Authorization"] = `Bearer ${jwt}`;
    }
    const response = await fetch(url, {
      method,
      body,
      headers,
      credentials
    });
    if (!checkResponse(response)) {
      throw response;
    }
    const payload = await response.json();
    return payload;
  } catch (error) {
    throw createErrorPayload(error);
  }
}

function checkResponse(response) {
  if (!response) {
    throw "checkResponse: response is missing";
  }
  switch (response.status) {
    case 304:
    case 201:
    case 200: {
      return true;
    }
    case 401:
    case 403: {
      //redirectToLogin(constants.APP_BASE);
      return false;
    }
    default: {
      return false;
    }
  }
}
